export const newRow = {

}

export const dummyRows = [
    {
        id: 1,
        businessAreaValue: "Finance",
        sdCourseId: "SEC101",
        regularCourseId: "REG202",
        termValue: "Fall 2025",
        regularCourseIdDescription: "Intro to Finance",
        updatedOn: "2025-07-25",
        status: "Active",
        action: "Edit",
    },
    {
        id: 2,
        businessAreaValue: "HR",
        sdCourseId: "SEC102",
        regularCourseId: "REG203",
        termValue: "Spring 2025",
        regularCourseIdDescription: "Human Resources Basics",
        updatedOn: "2025-07-24",
        status: "Inactive",
        action: "View",
    },
    {
        id: 3,
        businessAreaValue: "IT",
        sdCourseId: "SEC103",
        regularCourseId: "REG204",
        termValue: "Summer 2025",
        regularCourseIdDescription: "Cybersecurity 101",
        updatedOn: "2025-07-23",
        status: "Pending",
        action: "Approve",
    },
]

export const statusFilterOptions = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' },
    { label: 'All', value: 'ALL' },
]

export const bulkActiveActionsDropdown = [
    { label: "Auto-Initiate", value: "autoInitiate" },
    { label: "Mark All Expired", value: "markAllExpired" },
    { label: "Block-RFID", value: "blockRFIDs" },
]
export const bulkInactiveActionsDropdown = [
    { label: "Mark All Active", value: "markAllActive" },
]

export const notificationConfigList = [
    { key: 'whatsApp', title: 'Whatsapp' },
    { key: 'sms', title: 'SMS' },
    { key: 'email', title: 'Email' },
];

export const initialForm = {
    sdCourseId: [],
    regularCourseId: [],
    businessAreaValue: [],
    termValue: []
}

export const formatNotificationType = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const createBulkRequest = (selectedRow, action) => ({
    "ids": selectedRow,
    "status": action?.value == "markAllActive" ? 'ACTIVE' : action?.value == 'markAllExpired' ? 'EXPIRED' : null,
    "blockRfidFlag": action?.value == 'blockRFIDs' ? true : null,
    "cronEnabled": action?.value == 'autoInitiate' ? true : null
})

export const statusDropdown = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Expired', value: 'EXPIRED' },
    { label: 'Inactive', value: 'INACTIVE' },

]
export const getStatusStyles = (status) => {
    if (status === "ACTIVE") {
        return {
            bgColor: "#E6F4ED",
            textColor: "#07794C",
        };
    } else if (status === "INACTIVE") {
        return {
            bgColor: "#F5F5F5",
            textColor: "#262626",
        }
    }
    else
        return {
            bgColor: "#FCEEED",
            textColor: "#DC2804",
        };

};

export const getStatusDropdown=(status)=>{
return status&&(status.toUpperCase()=='ACTIVE'||status.toUpperCase()=='EXPIRED' 
? {label:"Expired", value:"EXPIRED"}
:{label:"Active", value:"ACTIVE"})
}
